module.exports = __webpack_public_path__ + "img/cloth_g3_shirt-12.9bb83ffa.svg";